import type { JSX } from 'react';

import * as styles from 'pkg/config/styles';

import MaterialSymbol from 'components/material-symbols';

import type { MaterialSymbolVariant } from 'components/material-symbols/symbols';

import * as css from './styles.css';

interface FullPageMessageProps {
	icon?: MaterialSymbolVariant;
	iconColor?: keyof typeof styles.palette.Colors;
	title: string;
	message?: string;
}

export default function FullPageMessage({
	icon = 'check_circle',
	iconColor = 'green',
	title,
	message = null,
}: FullPageMessageProps): JSX.Element {
	return (
		<div className={css.wrapper}>
			<MaterialSymbol variant={icon} fill={styles.palette[iconColor][400]} />
			<span>{title}</span>
			{message && <p>{message}</p>}
		</div>
	);
}
